import validate from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@24.9.1_eslint-ts-patch@8.56.0-0_magicast@_e1f5fa368ce54843bf5b5a5ae2ba2e14/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/opt/buildhome/repo/node_modules/.pnpm/nuxt@3.10.1_@parcel+watcher@2.5.1_@types+node@24.9.1_eslint-ts-patch@8.56.0-0_magicast@_e1f5fa368ce54843bf5b5a5ae2ba2e14/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}